<template>
  <div>
    <Container>
      <div class="container heading text-left text-md-center">
        <h1 class="title" v-text="blog.title"></h1>
        <div class="date">
          <span v-text="blog.disp_date"></span>
          <span class="mx-1">&bull;</span>
          <span>By {{ app_name() }}</span>
        </div>
      </div>
      <Share :tags="seoTagsToArr(blog.seo_tags) || []" />
      <div class="thumbnail">
        <img v-lazy="blog.thumbnail" :alt="blog.title" class="img-fluid" />
      </div>
      <div class="container">
        <article>
          <div v-html="blog.description"></div>
        </article>
        <Share :tags="seoTagsToArr(blog.seo_tags) || []" />
      </div>
      <hr class="mt-4 mb-0" />
    </Container>
    <Featured
      :excluedIds="[blog.id]"
      v-if="blog && blog.id"
      title="Related Blogs"
      :description="null"
    />
    <Container>
      <hr class="mb-4 mt-0" />
      <SocialLinks class="mt-4" />
    </Container>
  </div>
</template>
<script>
import Share from "../shared/share.vue";
import Featured from "./featured.vue";
export default {
  components: {
    SocialLinks: () =>
      import(
        /* webpackChunkName: "home-shared-social-links" */ "../shared/socialLinks"
      ),
    Share,
    Featured,
  },
  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    blog() {
      return this.data.data;
    },
  },
};
</script>
<style lang="scss" scoped>
.heading {
  margin-top: 1.2rem;
  margin-bottom: 2rem;
  color: var(--dark);
  .title {
    font-size: 2.6rem;
    font-weight: bold;
    margin-bottom: 0.5rem;
  }
  .date {
    font-size: 1rem;
    opacity: 0.7;
  }

  @media (max-width: 768px) {
    .title {
      font-size: 2.2rem;
    }
  }

  @media (max-width: 576px) {
    .title {
      font-size: 1.8rem;
    }
  }
}
.thumbnail {
  margin-bottom: 1.2rem;
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    max-height: max(800px, 60vh);
    box-shadow: var(--box-shadow);
    border-radius: var(--border-radius);
  }
}
article {
  line-height: 1.1;
  color: var(--font-color);
  p {
    margin-bottom: 0.9rem;
  }
  a {
    color: var(--primary);
    text-decoration: underline;
  }
}
</style>